import React from 'react';
import { Shield } from 'lucide-react';

export const Header = () => {
  return (
    <header className="text-center mb-8">
      <h1 className="text-3xl sm:text-4xl font-bold text-h1 mb-3">
        Power Skills Wheel
      </h1>
      <p className="text-lg sm:text-xl text-h2 font-medium mb-4">
        One spin. One skill. One power move.
      </p>
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary/50 border border-border">
        <Shield className="w-4 h-4 text-primary" />
        <span className="text-sm text-helper">
          No tracking. Saved on your device.
        </span>
      </div>
    </header>
  );
};

export default Header;
